import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {useFormikContext} from 'formik';
import Pencil from '../../../../assets/icons/Pencil';
import {clearText} from '../../../../component/textEditor/TextEditorHelpers';
import {BreakFormValues} from './ManageBreakPopup';
import * as css from './ManageBreakPopup.css';

export const DESCRIPTION_MAX = 350;

const SummaryHeader: FC = () => {
    const {t} = useTranslation('timetable');
    const {values} = useFormikContext<BreakFormValues>();
    const charCount = clearText(values.description || '').length;
    return (
        <css.summaryHeader>
            <Pencil />
            <css.summaryLabel>{t('summaryPlaceholder')}</css.summaryLabel>
            <css.charCounter>
                {charCount}/{DESCRIPTION_MAX} <b>{t('summaryChars')}</b>
            </css.charCounter>
        </css.summaryHeader>
    );
};

export default SummaryHeader;
